import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MeetingService } from '../../services/meeting.service';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { ToasterService } from 'angular2-toaster';

@Component({
  selector: 'app-passreset',
  templateUrl: './passreset.component.html',
  styleUrls: ['./passreset.component.css']
})
export class PassresetComponent implements OnInit {

  busy: Promise<any>;
  person: any = {};
  passform: FormGroup;
  submitAttempt: boolean;
  id: any;

  error;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _cookieService: CookieService,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private meetingService: MeetingService) {}

  matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
      return (group: FormGroup): {[key: string]: any} => {
        const password = group.controls[passwordKey];
        const confirmPassword = group.controls[confirmPasswordKey];

        if (password.value !== confirmPassword.value) {
          return {
            mismatchedPasswords: true
          };
        }
      };
    }

  ngOnInit() {

    this.passform = this.formBuilder
      .group({
        pass1: ['', Validators.compose([Validators.required])],
        pass2: ['', Validators.required],
      },
      {
        validator: this.matchingPasswords('pass1', 'pass2')
      }
    );

    this.route.params.subscribe(params => this.id = params['id']);
  }

  isPassFormControlDirty(controlName: string): boolean {
    return this.passform.get(controlName).dirty;
  }

  submit() {
    this.submitAttempt = true;
    if (!this.passform.valid) {
        // console.log("not valid");
    } else {
      // console.log(this.person.pass1);
      // console.log(this.person.pass2);
      const $this = this;

      this.busy = this.meetingService.ResetPassword(this.person.pass1, this.person.pass2, this.id).subscribe(response => {
                  if (+response.success === 1) {
                    // console.log(response);
                    const success_msg = response.message;
                    // console.log(success_msg);
                    $this._cookieService.put('msg', success_msg);
                    // const link = ['/login'];
                    $this.router.navigateByUrl('/login');
                    $this.toasterService.pop('success', response.message);
                    // window.location.href = "http://ovo.dev.bluelightit.com/?message=Success.%20Please%20login";
                  } else {
                    $this.toasterService.pop('error', response.message);
                  }
                });
    }
  }

}
